module.exports = __webpack_public_path__ + "img/2.e32a728d.svg";